import React, { useEffect, useState } from "react";
import Layout from "../components/layout";
import { Link } from "react-router-dom";
import { MdOutlineChevronRight } from "react-icons/md";
import { FaCheck } from "react-icons/fa";
import { Users, Target, Heart, Megaphone, Headphones } from 'lucide-react';

const Inficonnect = () => {
  const imagesSlider1 = ["/slider1.png", "/slider2.png", "/slider3.png"];
  const imagesSlider2 = ["/slider2.png", "/slider3.png", "/slider1.png"];
  const logos = [
    { id: 1, href: "#", imgSrc: "/brands/Frame 1.png", alt: "Microsoft" },
    { id: 2, href: "#", imgSrc: "/brands/Frame 2.png", alt: "microsoft" },
    { id: 3, href: "#", imgSrc: "/brands/Frame 3.png", alt: "microsoft" },
    { id: 4, href: "#", imgSrc: "/brands/Frame 4.png", alt: "microsoft" },
    { id: 5, href: "#", imgSrc: "/brands/Frame 5.png", alt: "microsoft" },
    { id: 6, href: "#", imgSrc: "/brands/Frame 6.png", alt: "microsoft" },
    { id: 7, href: "#", imgSrc: "/brands/Frame 7.png", alt: "Microsoft" },
    { id: 8, href: "#", imgSrc: "/brands/Frame 8.png", alt: "Microsoft" },
    { id: 9, href: "#", imgSrc: "/brands/Frame 9.png", alt: "Microsoft" },
    { id: 10, href: "#", imgSrc: "/brands/Frame 10.png", alt: "Microsoft" },
  ];

  const [offset1, setOffset1] = useState(100);
  const [offset2, setOffset2] = useState(400);
  const [direction1, setDirection1] = useState("down");
  const [direction2, setDirection2] = useState("up");
  const [translateX, setTranslateX] = useState(0);
  const logoWidth = 200; // Adjust the logo width (in px)
  const totalWidth = logoWidth * logos.length * 2; // Multiply by 2 for the duplicate logos

  useEffect(() => {
    const interval = setInterval(() => {
      setTranslateX((prev) => prev - 1); // Adjust this value for speed (negative to scroll left)
    }, 10); // Time interval for smooth scrolling

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    // When the first set of logos has fully scrolled off, reset to the start (without any gap)
    if (Math.abs(translateX) >= totalWidth / 2) {
      setTranslateX(0); // Reset position for a seamless loop
    }
  }, [translateX]);

  useEffect(() => {
    const interval = setInterval(() => {
      setOffset1((prevOffset) => {
        const nextOffset =
          direction1 === "down" ? prevOffset + 1 : prevOffset - 1;
        if (nextOffset > imagesSlider1.length * 200 - 90) setDirection1("up");
        if (nextOffset < 0) setDirection1("down");
        return nextOffset;
      });

      setOffset2((prevOffset) => {
        const nextOffset =
          direction2 === "down" ? prevOffset + 1 : prevOffset - 1;
        if (nextOffset > imagesSlider2.length * 200 - 90) setDirection2("up");
        if (nextOffset < 0) setDirection2("down");
        return nextOffset;
      });
    }, 10);

    return () => clearInterval(interval);
  }, [direction1, direction2, imagesSlider1.length, imagesSlider2.length]);

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = '/inficonnect/app-release.apk';
    link.download = 'inficonnect.apk';
    link.click();
  };

  const rolesData = [
    {
      role: "Store Staff",
      help: "Easily message & invite high-value customers nearby",
      icon: Users,
    },
    {
      role: "Marketers",
      help: "Run segmented campaigns with predictive analytics",
      icon: Target,
    },
    {
      role: "CRM Teams",
      help: "Boost retention with loyalty-driven personalization",
      icon: Heart,
    },
    {
      role: "Brand Teams",
      help: "Deliver consistent, elegant messages on every channel",
      icon: Megaphone,
    },
    {
      role: "CX Leaders",
      help: "Provide cross-channel support with centralized visibility",
      icon: Headphones,
    },
  ];

  const steps = [
    {
      title: "Step 1",
      description: "Connect CMS, CRM & POS",
    },
    {
      title: "Step 2",
      description: "Access segment customers by intent, location, or history",
    },
    {
      title: "Step 3",
      description: "Use AI to recommend catalogs or message templates",
    },
    {
      title: "Step 4",
      description: "Staff uses the application and sends personalised catalogues via WhatsApp",
    },
    {
      title: "Step 5",
      description: "Track real-time click, online purchase",
    },
    {
      title: "Step 6",
      description: "AI improves results with each interaction",
    },
  ];

  return (
    <Layout>
      <div className=" min-h-screen flex flex-col items-center">
        <div class="bg-[#EDE8EE] w-full">
          <div className="max-w-screen-xl xl:max-w-screen-2xl px-4 py-8 mx-auto xl:h-[90vh] lg:gap-8 xl:gap-4 xl:py-0 lg:grid-cols-12 xl:pt-0 justify-center">
            <div className="w-full flex flex-col items-center justify-center text-center px-5 py-10">
              <h1 className="max-w-4xl text-3xl md:text-6xl xl:text-7xl font-bold leading-tight tracking-tight">
                Turn Customer Data into Real-World Footfall
              </h1>
              <p className="max-w-xl my-6 text-base md:text-lg lg:text-xl">
                Inficonnect empowers fashion retail brands to create deeply personalized customer journeys, bridging online and offline with AI-driven tools for in-store invitations, offer sharing, and omnichannel engagement powered by WhatsApp.
              </p>
              <div className="flex flex-wrap justify-center gap-4 mt-4">
                <Link to="/products/sales/inficonnect/signup">
                  <button className="bg-[#7453E0] text-white text-sm md:text-base font-semibold px-4 py-2 rounded-sm flex items-center gap-2">
                    Get Started
                    <MdOutlineChevronRight className="mt-[2px]" fontSize="large" />
                  </button>
                </Link>
                <Link to="https://inficonnect.fixall.ai/">
                  <button className="bg-[#7453E0] text-white text-sm md:text-base font-semibold px-4 py-2 rounded-sm flex items-center gap-2">
                    Login to Inficonnect
                    <MdOutlineChevronRight className="mt-[2px]" fontSize="large" />
                  </button>
                </Link>
              </div>
              {/* <div className="flex flex-wrap justify-center gap-4 mt-6">
                <button
                  className="hover:bg-[#7453E0] border-2 text-[#7453E0] border-[#7453E0] hover:text-white text-sm md:text-base font-semibold px-4 py-2 rounded-sm flex items-center gap-2"
                  onClick={handleDownload}
                >
                  Download APK
                  <IoLogoAndroid className="text-xl md:text-2xl" />
                </button>
                <button
                  className="hover:bg-[#7453E0] border-2 text-[#7453E0] border-[#7453E0] hover:text-white text-sm md:text-base font-semibold px-4 py-2 rounded-sm flex items-center gap-2"
                  onClick={() => toast.error("Currently this is not available.")}
                >
                  Download IPA
                  <DiApple className="text-xl md:text-2xl" />
                </button>
              </div> */}
            </div>


            {/* <div className="flex w-full h-[90vh]"> */}
            {/* <div class="hidden lg:mt-0 lg:col-span-5 h-full lg:flex hidden">
              <div className="w-1/2 overflow-hidden relative">
                <div
                  className="absolute"
                  style={{
                    transform: `translateY(-${offset1}px)`,
                    transition: "transform 0.1s linear",
                  }}
                >
                  {imagesSlider1.map((img, index) => (
                    <img
                      key={index}
                      src={img}
                      alt={`Slider1-${index}`}
                      className="w-full h-auto object-cover"
                    />
                  ))}
                </div>
              </div>

              <div className="w-1/2 overflow-hidden relative">
                <div
                  className="absolute"
                  style={{
                    transform: `translateY(-${offset2}px)`,
                    transition: "transform 0.5s linear",
                  }}
                >
                  {imagesSlider2.map((img, index) => (
                    <img
                      key={index}
                      src={img}
                      alt={`Slider2-${index}`}
                      className="w-full h-auto object-cover"
                    />
                  ))}
                </div>
              </div>
            </div> */}
          </div>
        </div>


        <div className="bg-[#251230] text-white border-t border-[#251230] w-full h-auto">
          <div className="bg-[#EDE8EE] w-full">
            <div className="text-center capitalize py-4 lg:px-4 md:px-4 md:py-4 max-w-screen-xl xl:max-w-screen-2xl mx-auto">
              <h1 className="text-lg md:text-3xl font-semibold text-[#251230]">
                What is Inficonnect? The Hyperlocal Engagement Engine
              </h1>
            </div>
          </div>
          <div className="subTitle text-center pt-8">
            <p>
              Inficonnect is a retail engagement platform built for fashion brands with physical stores and digital presence.
            </p>
            <p>
              It gives store staff, marketers, and CX teams the power to
            </p>
          </div>
          <div className="max-w-screen-xl xl:max-w-screen-2xl mx-auto flex flex-col-reverse lg:flex-row items-center h-auto">
            <div className="flex flex-col-reverse lg:flex-row justify-center items-center gap-8 px-4 py-10 w-full">
              {/* Left Content */}
              <div className="flex flex-col items-center lg:items-end text-center lg:text-left max-w-full lg:max-w-[35%] space-y-6">
                <div>
                  <h2 className="text-lg font-semibold">
                    Create tailored catalogs and campaigns
                  </h2>
                  <p className="text-xs lg:text-sm">
                    Create personalized catalogs and targeted campaigns that resonate with your audience. Boost engagement and drive conversions through tailored content strategies.
                  </p>
                </div>
                <div>

                  <h2 className="text-lg font-semibold">
                    Send personalized WhatsApp invites and previews
                  </h2>
                  <p className="text-xs lg:text-sm">
                    Engage your audience with customized WhatsApp invites tailored to their interests. Share dynamic previews that boost response rates and drive deeper interactions
                  </p>
                </div>
              </div>

              {/* Center Image */}
              <div className="relative w-40 h-40 lg:w-64 lg:h-64 lg:max-w-[30%] rounded-full flex items-center justify-center">
                <img
                  src="/engagementBackground.png"
                  alt="Center Icon"
                  className="w-full h-full object-cover rotateCenter"
                />
              </div>

              {/* Right Content */}
              <div className="flex flex-col items-center lg:items-start text-center lg:text-left max-w-full lg:max-w-[35%] space-y-6">
                <div>
                  <h2 className="text-lg font-semibold">Use AI to predict outcomes and recommend content</h2>
                  <p className="text-xs md:text-sm">
                    Leverage AI to analyze user behavior and forecast future trends with precision. Deliver smarter, personalized content recommendations that maximize impact.
                  </p>
                </div>
                <div>
                  <h2 className="text-lg font-semibold">
                    Track conversions from message → footfall → sale
                  </h2>
                  <p className="text-xs md:text-sm">
                    Monitor the entire customer journey from message delivery to in-store visits and final purchases. Gain valuable insights to optimize your campaigns and maximize ROI.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <section className="relative w-full bg-[#EDE8EE]  h-[80vh]">
          <div className='max-w-screen-xl xl:max-w-screen-2xl mx-auto  flex flex-col-reverse md:flex-row items-center h-full'>
            <div className="w-full md:w-1/2 space-y-6 md:space-y-8 px-4 md:px-8 py-12 md:py-20">
              <h1 className="text-2xl md:text-4xl font-semibold text-[#251230] leading-tight">
                The Importance of <br /> Retail Stores in <br /> Customer Engagement
              </h1>
              <p className="text-gray-600 text-base md:text-xl">
                Retail Stores Play a vital role in fostering critical customer engagement.
              </p>

              <Link to="/products/sales/inficonnect/signup" >
                <button className=" text-[#F48FB1] font-semibold pt-5">
                  InfiConnect
                </button>
              </Link>
            </div>

            <div className="w-1/2 h-full  flex justify-center relative">
              <img
                src="/inficonnectBackground.jpg"
                alt="Product Catalog Illustration"
                className="w-full h-full "
              />
              <div class="hidden lg:mt-0 lg:col-span-5 h-full lg:flex">
                <div className="w-1/2 overflow-hidden relative">
                  <div
                    className="absolute"
                    style={{
                      transform: `translateY(-${offset1}px)`,
                      transition: "transform 0.1s linear",
                    }}
                  >
                    {imagesSlider1.map((img, index) => (
                      <img
                        key={index}
                        src={img}
                        alt={`Slider1-${index}`}
                        className="w-full h-auto object-cover"
                      />
                    ))}
                  </div>
                </div>

                <div className="w-1/2 overflow-hidden relative">
                  <div
                    className="absolute"
                    style={{
                      transform: `translateY(-${offset2}px)`,
                      transition: "transform 0.5s linear",
                    }}
                  >
                    {imagesSlider2.map((img, index) => (
                      <img
                        key={index}
                        src={img}
                        alt={`Slider2-${index}`}
                        className="w-full h-auto object-cover"
                      />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> */}

        <div className="lg:flex-row items-center bg-[#EDE8EE] text-[#251230] py-10 lg:px-16 px-6 lg:py-12 w-full h-full">
          {/* Left Container */}
          <h1 className="text-lg text-center md:text-3xl font-semibold text-[#251230]">
            Why Inficonnect? Deliver Value
          </h1>
          <h1 className="text-lg text-center mb-5 md:text-3xl font-semibold text-[#251230]">
            Beyond the Transaction
          </h1>
          <div className="max-w-screen-xl xl:max-w-screen-2xl mx-auto flex flex-col-reverse md:flex-row h-[100%] max-h-full gap-10">
            <div className="grid grid-cols-1 gap-6 md:grid-cols-4 md:gap-6">
              {/* Card 1 */}
              <div className="relative group rounded-lg transition-all duration-300">
                <div className="absolute -inset-0.5 rounded-lg opacity-0 group-hover:opacity-100 transition-all duration-300 bg-gradient-to-r from-pink-500 via-red-500 to-yellow-500 blur-sm"></div>
                <div className="relative z-10 rounded-lg p-5 pt-3 lg:pt-3 flex flex-col items-center shadow-md group-hover:shadow-xl transition-all duration-300 border bg-white">
                  <div className="mb-4">
                    <img
                      src="/automation1.png"
                      alt="Icon"
                      className="w-14 h-14 md:w-24 md:h-24"
                    />
                  </div>
                  <h2 className="text-base md:text-lg font-medium md:font-semibold text-center text-[#251230] rounded-xl px-2 py-2 w-full flex items-center justify-center">
                    Personalization
                  </h2>
                  <p className="text-sm text-center">
                    Share 1:1 greetings, offers, and catalogues via WhatsApp
                  </p>
                </div>
              </div>

              {/* Card 2 */}
              <div className="relative group rounded-lg transition-all duration-300">
                <div className="absolute -inset-0.5 rounded-lg opacity-0 group-hover:opacity-100 transition-all duration-300 bg-gradient-to-r from-pink-500 via-red-500 to-yellow-500 blur-sm"></div>
                <div className="relative z-10 bg-white rounded-lg p-5 pt-3 lg:pt-3 flex flex-col items-center shadow-md group-hover:shadow-xl transition-all duration-300">
                  <div className="mb-4">
                    {/* Replace with your image path */}
                    <img
                      src="/automation2.png"
                      alt="Consistency Icon"
                      className="w-14 h-14 md:w-24 md:h-24"
                    />
                  </div>
                  <h2 className="text-base md:text-lg font-medium md:font-semibold text-center text-[#251230] rounded-xl px-2 py-2 w-full flex items-center justify-center">
                    Loyalty Activation
                  </h2>
                  <p className="text-sm text-center">
                    Surprise repeat shoppers with early previews
                  </p>
                </div>
              </div>
              {/* Card 3 */}
              <div className="relative group rounded-lg transition-all duration-300">
                <div className="absolute -inset-0.5 rounded-lg opacity-0 group-hover:opacity-100 transition-all duration-300 bg-gradient-to-r from-pink-500 via-red-500 to-yellow-500 blur-sm"></div>
                <div className="relative z-10 bg-white rounded-lg p-5 pt-3 lg:pt-3 flex flex-col items-center shadow-md group-hover:shadow-xl transition-all duration-300">
                  <div className="mb-4">
                    {/* Replace with your image path */}
                    <img
                      src="/automation3.png"
                      alt="Opportunities Icon"
                      className="w-14 h-14 md:w-24 md:h-24"
                    />
                  </div>
                  <h2 className="text-base md:text-lg font-medium md:font-semibold text-center text-[#251230] rounded-xl px-2 py-2 w-full flex items-center justify-center">
                    Hyperlocal Sales
                  </h2>
                  <p className="text-sm text-center">
                    Empower local staff to engage nearby customers
                  </p>
                </div>
              </div>
              <div className="relative group rounded-lg transition-all duration-300">
                <div className="absolute -inset-0.5 rounded-lg opacity-0 group-hover:opacity-100 transition-all duration-300 bg-gradient-to-r from-pink-500 via-red-500 to-yellow-500 blur-sm"></div>
                <div className="relative z-10 bg-white rounded-lg p-5 pt-3 lg:pt-3 flex flex-col items-center shadow-md group-hover:shadow-xl transition-all duration-300">
                  <div className="mb-4">
                    {/* Replace with your image path */}
                    <img
                      src="/automation3.png"
                      alt="Opportunities Icon"
                      className="w-14 h-14 md:w-24 md:h-24"
                    />
                  </div>
                  <h2 className="text-base md:text-lg font-medium md:font-semibold text-center text-[#251230] rounded-xl px-2 py-2 w-full flex items-center justify-center">
                    Smarter Engagement
                  </h2>
                  <p className="text-sm text-center">
                    AI recommends offers & predicts ROI per customer
                  </p>
                </div>
              </div>
              <div className="relative group rounded-lg transition-all duration-300">
                <div className="absolute cursor-pointer -inset-0.5 rounded-lg opacity-0 group-hover:opacity-100 transition-all duration-300 bg-gradient-to-r from-pink-500 via-red-500 to-yellow-500 blur-sm"></div>
                <div className="relative hoverEffect z-10 rounded-lg bg-white p-5 pt-3 lg:pt-3 flex flex-col items-center shadow-md group-hover:shadow-xl transition-all duration-300">
                  <div className="mb-4">
                    <img
                      src="/automation3.png"
                      alt="Opportunities Icon"
                      className="w-14 h-14 md:w-24 md:h-24"
                    />
                  </div>
                  <h2 className="text-base md:text-lg font-medium md:font-semibold text-center text-[#251230] rounded-xl px-2 py-2 w-full flex items-center justify-center">
                    Effortless Integration
                  </h2>
                  <p className="text-sm text-center">
                    Syncs with your CRM, POS, and existing tools
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="text-white py-12 w-full px-6 lg:px-12" style={{ background: "#251230" }}>
          <div className="w-full">
            <div className="text-center mt-5 capitalize max-w-screen-xl xl:max-w-screen-2xl mx-auto">
              <h1 className="text-xl md:text-3xl font-medium md:font-semibold text-[#fff]">
                What You Can Do with Inficonnect?
              </h1>
            </div>
          </div>
          <div className="max-w-screen-xl xl:max-w-screen-2xl lg:py-8 py-4 lg:px-4 px-0 mx-auto grid grid-cols-1 lg:grid-cols-2 gap-6">
            <div className="flex space-x-4 border shadow-md bg-white rounded-lg">
              <div className="w-full">
                <div className="text-lg font-semibold bg-[#EA688A] px-2 md:px-5 md:pl-2 lg:py-1 py-3 md:py-2 flex items-center rounded-md gap-2 md:gap-5 w-full">
                  <h2 className="text-sm font-normal md:text-lg md:font-semibold">
                    Personalize the Shopping Experience
                  </h2>
                </div>
                <ul className="textColor p-4 pt-2">
                  <li className="text-xs md:text-sm mt-2">
                    Let store staff select customers by buying history, preferences, or seasonality
                  </li>
                  <li className="text-xs md:text-sm mt-2">
                    Instantly create and share visual catalogs, festive greetings, and invite messages
                  </li>
                  <li className="text-xs md:text-sm mt-2">
                    Send via WhatsApp with branded templates and real-time response tracking
                  </li>
                </ul>
              </div>
            </div>
            <div className="flex space-x-4 border shadow-md bg-white rounded-lg">
              {/* <div className="flex-shrink-0">
                <img
                  src="/manualProcess2.png"
                  alt="Inefficiency Icon"
                  className="w-10 h-10 md:w-14 md:h-14"
                />
              </div> */}
              <div className="w-full">
                <div className="text-lg font-semibold bg-[#EA688A] px-2 md:px-5 md:pl-2 lg:py-1 py-3 md:py-2 flex items-center rounded-md gap-2 md:gap-5 w-full">
                  {/* <div className="px-1 py-0.5 rounded-full border-[1px] md:w-8 md:h-8 flex items-center justify-center border-white text-xs md:text-base font-normal">
                    <p>02</p>
                  </div> */}
                  <h2 className="text-sm font-normal md:text-lg md:font-semibold">
                    Offer Value Beyond Products
                  </h2>
                </div>
                <ul className="textColor p-4 pt-2">
                  <li className="text-xs md:text-sm mt-2">
                    Surprise and reward loyal customers with:
                  </li>
                  <ul>
                    <li>
                      Exclusive offers
                    </li>
                    <li>
                      Early access to collections
                    </li>
                    <li>Private preview invites</li>
                    <li className="text-black">
                      Use customer persona to tailor every message
                    </li>
                  </ul>
                </ul>
              </div>
            </div>
            <div className="flex space-x-4 border bg-white shadow-md rounded-lg">
              {/* <div className="flex-shrink-0">
                <img
                  src="/manualProcess3.png"
                  alt="Marketing Icon"
                  className="w-10 h-10 md:w-14 md:h-14"
                />
              </div> */}
              <div className="w-full">
                <div className="text-lg font-semibold bg-[#EA688A] px-2 md:px-5 md:pl-2 lg:py-1 py-3 md:py-2 flex items-center rounded-md gap-2 md:gap-5 w-full">
                  {/* <div className="px-1 py-0.5 rounded-full border-[1px] md:w-8 md:h-8 flex items-center justify-center border-white text-xs md:text-base font-normal">
                    <p>03</p>
                  </div> */}
                  <h2 className="text-sm font-normal md:text-lg md:font-semibold">
                    Empower Engagement with AI Cognition
                  </h2>
                </div>
                <ul className="textColor p-4 pt-2">
                  <li>
                    Predict which engagements will drive ROI
                  </li>
                  <li>
                    AI-recommended message templates, catalog combinations, and timing
                  </li>
                  <li>
                    Real-time suggestions based on sales and response data
                  </li>
                </ul>
              </div>
            </div>
            <div className="flex space-x-4 border bg-white shadow-md rounded-lg">
              {/* <div className="flex-shrink-0">
                  <img
                    src="/manualProcess4.png"
                    alt="Disconnection Icon"
                    className="w-10 h-10 md:w-14 md:h-14"
                  />
                </div> */}
              <div className="w-full">
                <div className="text-lg font-semibold bg-[#EA688A] px-2 md:px-5 md:pl-2 lg:py-1 py-3 md:py-2 flex items-center rounded-md gap-2 md:gap-5 w-full">
                  {/* <div className="px-1 py-0.5 rounded-full border-[1px] md:w-8 md:h-8 flex items-center justify-center border-white text-xs md:text-base font-normal">
                    <p>04</p>
                  </div> */}
                  <h2 className="text-sm font-normal md:text-lg md:font-semibold">
                    Seamless Omnichannel Support
                  </h2>
                </div>
                <ul className="textColor p-4 pt-2">
                  <li className="text-xs md:text-sm mt-2">
                    Bridge in-store and digital touchpoints:
                  </li>
                  <ul className="textColor">
                    <li>
                      In-app chat
                    </li>
                    <li>
                      WhatsApp follow-ups
                    </li>
                    <li>
                      Social DM responses
                    </li>
                    <li>
                      In-store pickup triggers
                    </li>
                  </ul>
                  <li>
                    Maintain context across all customer conversations
                  </li>
                </ul>
              </div>
            </div>

            <div className="flex space-x-4 border bg-white shadow-md rounded-lg">
              <div className="w-full">
                <div className="text-lg font-semibold bg-[#EA688A] px-2 md:px-5 md:pl-2 lg:py-1 py-3 md:py-2 flex items-center rounded-md gap-2 md:gap-5 w-full">
                  <h2 className="text-sm font-normal md:text-lg md:font-semibold">
                    Effortless Integration
                  </h2>
                </div>
                <ul className="textColor p-4 pt-2">
                  <li className="text-xs md:text-sm mt-2">
                    Plug-and-play with:
                  </li>
                  <ul className="textColor">
                    <li>
                      POS (to sync sales and redemption data)
                    </li>
                    <li>
                      CRM (to access purchase history and profiles)
                    </li>
                    <li>
                      CMS (to access catalogue, SKUs, pricing, and promos)
                    </li>
                    <li>
                      Loyalty engines, campaign tools, ticketing platforms
                    </li>
                  </ul>
                  <li>
                    Inficonnect adapts to your stack not the other way around.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-white py-12 px-6 sm:px-12 md:px-20">
          <h2 className="text-3xl font-bold text-center mb-10">Who is it for?</h2>
          <div className="grid md:grid-cols-2 gap-10">
            {rolesData.map((item, idx) => {
              const Icon = item.icon;
              return (
                <div
                  key={idx}
                  className="bg-white boxShadow shadow-xl p-6 flex items-start space-x-4 border border-gray-100"
                >
                  <div className="flex-shrink-0 w-14 h-14 rounded-full flex items-center justify-center text-white font-bold text-xl" style={{ background: "rgb(116, 83, 224)" }}>
                    <Icon />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-800">
                      {item.role}
                    </h3>
                    <p className="text-gray-600 mt-1">{item.help}</p>
                  </div>
                </div>
              );
            })}
          </div>

        </div>

        <div className="bg-[#251230] text-white border-t border-[#251230] w-full h-auto hidden">
          <div className="bg-[#EDE8EE] w-full">
            <div className="text-center capitalize p-4 max-w-screen-xl xl:max-w-screen-2xl mx-auto">
              <h1 className="text-xl md:text-3xl font-medium md:font-semibold text-[#251230]">
                Introduction to InfiConnect
              </h1>
            </div>
          </div>
          <div className="max-w-screen-xl xl:max-w-screen-2xl mx-auto flex flex-col-reverse md:flex-row items-center h-auto md:px-4 md:py-10">
            <div className="flex flex-col-reverse lg:flex-row justify-center items-center gap-8 px-4 py-10 w-full">
              {/* Left Content */}
              <div className="flex flex-col items-center lg:items-end text-center lg:text-right max-w-full lg:max-w-[35%] space-y-6">
                <div className="flex flex-col-reverse md:flex-col-reverse lg:flex-row items-center justify-center space-y-4 lg:space-y-0 lg:space-x-4">
                  <div>
                    <h2 className="text-lg font-semibold">
                      Leveraging Staff Connections
                    </h2>
                    <p className="text-sm">
                      The technology leverages store staff's personal
                      connections to improve customer engagement.
                    </p>
                  </div>
                  <div className="flex-shrink-0">
                    <img
                      src="/inficonnectIntroduction1.png"
                      alt="Struggle Icon"
                      className="w-14 h-14"
                    />
                  </div>
                </div>
                <div className="flex flex-col-reverse md:flex-col-reverse lg:flex-row items-center justify-center space-y-4 lg:space-y-0 lg:space-x-4">
                  <div>
                    <h2 className="text-lg font-semibold">
                      Enhanced In-Store Experience
                    </h2>
                    <p className="text-sm">
                      InfiConnect enhances the in-store experience by providing
                      personalized offerings and timely information.
                    </p>
                  </div>
                  <div className="flex-shrink-0">
                    <img
                      src="/inficonnectIntroduction2.png"
                      alt="Struggle Icon"
                      className="w-14 h-14"
                    />
                  </div>
                </div>
              </div>

              {/* Center Image */}
              <div className="relative w-40 h-40 md:w-64 md:h-64 rounded-full flex items-center justify-center">
                <img
                  src="/inficonnectIntroductionMain.png"
                  alt="Center Icon"
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Right Content */}
              <div className="flex flex-col items-center lg:items-start text-center lg:text-left max-w-full lg:max-w-[35%] space-y-6">
                <div className="flex flex-col lg:flex-row items-center justify-center space-y-4 lg:space-y-0 lg:space-x-4">
                  <div className="flex-shrink-0">
                    <img
                      src="/inficonnectIntroduction3.png"
                      alt="Struggle Icon"
                      className="w-14 h-14"
                    />
                  </div>
                  <div className="mb-4 lg:mb-8">
                    <h2 className="text-lg font-semibold">
                      Robust Tech Solution
                    </h2>
                    <p className="text-sm">
                      Inficonnect is designed to be a robust yet handy
                      technology solution for retailers.
                    </p>
                  </div>
                </div>
                <div className="flex flex-col lg:flex-row items-center justify-center space-y-4 lg:space-y-0 lg:space-x-4">
                  <div className="flex-shrink-0">
                    <img
                      src="/inficonnectIntroduction4.png"
                      alt="Struggle Icon"
                      className="w-14 h-14"
                    />
                  </div>
                  <div className="mb-4 lg:mb-8">
                    <h2 className="text-lg font-semibold">
                      Tailored Real-Time Updates
                    </h2>
                    <p className="text-sm">
                      This solution enables retailers to deliver tailored,
                      real-time updates to their customers.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 
      <div className="bg-gray-100 py-12 flex flex-col items-center">
        <h1 className="text-3xl font-semibold mb-8 text-gray-800">Pricing Plans</h1>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl">
          <div className="rounded-lg shadow-lg p-6 text-white bg-teal-500">
            <h2 className="text-2xl font-bold mb-4">Basic</h2>
            <p className="text-sm mb-4">Per User</p>
            <div className="flex justify-between items-center mb-6">
              <div>
                <p className="text-lg font-semibold">Monthly</p>
                <p className="text-xl font-bold">₹125</p>
              </div>
              <div>
                <p className="text-lg font-semibold">Annual</p>
                <p className="text-xl font-bold">₹100</p>
              </div>
            </div>
            <ul className="text-sm space-y-2">
              <li className="flex items-start">
                <span className="mr-2">✔️</span> Super Admin
              </li>
              <li className="flex items-start">
                <span className="mr-2">✔️</span> Three Levels: Super Admin > Admin > User
              </li>
              <li className="flex items-start">
                <span className="mr-2">✔️</span> Templates, Basic Analytics, WhatsApp, Email Integration
              </li>
              <li className="flex items-start">
                <span className="mr-2">✔️</span> Support center
              </li>
              <li className="flex items-start">
                <span className="mr-2">✔️</span> Max. no. of Catalogues/user/month = 50
              </li>
            </ul>
          </div>

          <div className="rounded-lg shadow-lg p-6 text-white bg-blue-500">
            <h2 className="text-2xl font-bold mb-4">Standard</h2>
            <p className="text-sm mb-4">Per User</p>
            <div className="flex justify-between items-center mb-6">
              <div>
                <p className="text-lg font-semibold">Monthly</p>
                <p className="text-xl font-bold">₹200</p>
              </div>
              <div>
                <p className="text-lg font-semibold">Annual</p>
                <p className="text-xl font-bold">₹150</p>
              </div>
            </div>
            <ul className="text-sm space-y-2">
              <li className="flex items-start">
                <span className="mr-2">✔️</span> Basic +
              </li>
              <li className="flex items-start">
                <span className="mr-2">✔️</span> AI Based Chatbot for Insights
              </li>
              <li className="flex items-start">
                <span className="mr-2">✔️</span> AI Based Catalog Curation
              </li>
              <li className="flex items-start">
                <span className="mr-2">✔️</span> Max. no. of Catalogues/user/month = 150
              </li>
            </ul>
          </div>

          <div className="rounded-lg shadow-lg p-6 text-white bg-purple-500">
            <h2 className="text-2xl font-bold mb-4">Enterprises</h2>
            <p className="text-sm mb-4">Per User</p>
            <div className="flex justify-between items-center mb-6">
              <div>
                <p className="text-lg font-semibold">Monthly</p>
                <p className="text-xl font-bold">₹250</p>
              </div>
              <div>
                <p className="text-lg font-semibold">Annual</p>
                <p className="text-xl font-bold">₹185</p>
              </div>
            </div>
            <ul className="text-sm space-y-2">
              <li className="flex items-start">
                <span className="mr-2">✔️</span> Standard +
              </li>
              <li className="flex items-start">
                <span className="mr-2">✔️</span> Coupon Mgt.
              </li>
              <li className="flex items-start">
                <span className="mr-2">✔️</span> Loyalty Mgt.
              </li>
              <li className="flex items-start">
                <span className="mr-2">✔️</span> Max. no. of Catalogues/user/month = Unlimited
              </li>
            </ul>
          </div>
        </div>
      </div> */}

        <div className="bg-gradient-to-r from-purple-300 via-pink-300 to-blue-300 xl:min-h-screen flex items-center justify-center py-10 px-4 w-full hidden">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 max-w-screen-xl xl:max-w-screen-2xl w-full">
            <div className="relative bg-white rounded-lg shadow-lg p-6 text-center transition-transform hover:scale-105">
              <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center">
                <span role="img" aria-label="fox">
                  🦊
                </span>
              </div>
              <div className="absolute top-0 right-0 bg-blue-500 text-white text-sm font-semibold px-3 py-1 rounded-bl-lg">
                ₹125/month
              </div>
              <h3 className="text-lg font-bold mt-8">Basic</h3>
              <p className="text-sm text-gray-500 mb-4">
                Complementary Features
              </p>
              <ul className="text-sm text-gray-700 space-y-2 mb-6 w-full lg:min-h-44">
                <li className="xl:w-[70%] lg:w-[80%] md:w-[60%] sm:w-[70%] w-[73%] ml-auto text-left flex items-start"><span className="mr-2 text-green-600 mt-1"><FaCheck /></span> <span className="inline-flex">Super Admin</span></li>
                <li className="xl:w-[70%] lg:w-[80%] md:w-[60%] sm:w-[70%] w-[73%] ml-auto text-left flex items-start"><span className="mr-2 text-green-600 mt-1"><FaCheck /></span> <span className="inline-flex">Support Center</span></li>
                <li className="xl:w-[70%] lg:w-[80%] md:w-[60%] sm:w-[70%] w-[73%] ml-auto text-left flex items-start"><span className="mr-2 text-green-600 mt-1"><FaCheck /></span> <span className="inline-flex">Templates, Basic Analytics</span></li>
                <li className="xl:w-[70%] lg:w-[80%] md:w-[60%] sm:w-[70%] w-[73%] ml-auto text-left flex items-start"><span className="mr-2 text-green-600 mt-1"><FaCheck /></span> <span className="inline-flex">WhatsApp & Email Integration</span></li>
                <li className="xl:w-[70%] lg:w-[80%] md:w-[60%] sm:w-[70%] w-[73%] ml-auto text-left flex items-start"><span className="mr-2 text-green-600 mt-1"><FaCheck /></span> <span className="inline-flex">Max. Catalogues: 50/user/month</span></li>
                <li className="xl:w-[70%] lg:w-[80%] md:w-[60%] sm:w-[70%] w-[73%] ml-auto text-left flex items-start"><span className="mr-2 text-green-600 mt-1"><FaCheck /></span> <span className="inline-flex">Three Levels: Super Admin &gt; Admin &gt; User</span></li>
              </ul>
              <button className="bg-blue-500 text-white font-medium px-4 py-2 rounded-full hover:bg-blue-600">
                Buy Now
              </button>
            </div>

            <div className="relative bg-white rounded-lg shadow-lg p-6 text-center transition-transform hover:scale-105 my-4 lg:my-0">
              <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 w-12 h-12 bg-gray-200 rounded-full flex items-center justify-center">
                <span role="img" aria-label="panda">
                  🐼
                </span>
              </div>
              <div className="absolute top-0 right-0 bg-purple-500 text-white text-sm font-semibold px-3 py-1 rounded-bl-lg">
                ₹200/month
              </div>
              <h3 className="text-lg font-bold mt-8">Standard</h3>
              <p className="text-sm text-gray-500 mb-4">
                Basic + Additional Features
              </p>
              <ul className="text-sm text-gray-700 space-y-2 mb-6 w-full lg:min-h-44">
                <li className="xl:w-[70%] lg:w-[80%] md:w-[60%] sm:w-[70%] w-[73%] ml-auto text-left flex items-start"><span className="mr-2 text-green-600 mt-1"><FaCheck /></span><span className="inline-flex"> AI-Based Chatbot for Insights</span></li>
                <li className="xl:w-[70%] lg:w-[80%] md:w-[60%] sm:w-[70%] w-[73%] ml-auto text-left flex items-start"><span className="mr-2 text-green-600 mt-1"><FaCheck /></span><span className="inline-flex"> AI-Based Catalog Curation</span></li>
                <li className="xl:w-[70%] lg:w-[80%] md:w-[60%] sm:w-[70%] w-[73%] ml-auto text-left flex items-start"><span className="mr-2 text-green-600 mt-1"><FaCheck /></span><span className="inline-flex"> Max. Catalogues: 150/user/month</span></li>
              </ul>
              <button className="bg-purple-500 text-white font-medium px-4 py-2 rounded-full hover:bg-purple-600">
                Buy Now
              </button>
            </div>

            <div className="relative bg-white rounded-lg shadow-lg p-6 text-center transition-transform hover:scale-105">
              <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 w-12 h-12 bg-yellow-100 rounded-full flex items-center justify-center">
                <span role="img" aria-label="unicorn">
                  🦄
                </span>
              </div>
              <div className="absolute top-0 right-0 bg-yellow-500 text-white text-sm font-semibold px-3 py-1 rounded-bl-lg">
                ₹250/month
              </div>
              <h3 className="text-lg font-bold mt-8">Enterprise</h3>
              <p className="text-sm text-gray-500 mb-4">
                Standard + Premium Features
              </p>

              <ul className="text-sm text-gray-700 space-y-2 mb-6 w-full lg:min-h-44">
                <li className="xl:w-[70%] lg:w-[80%] md:w-[60%] sm:w-[70%] w-[73%] ml-auto text-left flex items-start"><span className="mr-2 text-green-600 mt-1"><FaCheck /></span><span className="inline-flex"> Coupon Management</span></li>
                <li className="xl:w-[70%] lg:w-[80%] md:w-[60%] sm:w-[70%] w-[73%] ml-auto text-left flex items-start"><span className="mr-2 text-green-600 mt-1"><FaCheck /></span><span className="inline-flex"> Loyalty Management</span></li>
                <li className="xl:w-[70%] lg:w-[80%] md:w-[60%] sm:w-[70%] w-[73%] ml-auto text-left flex items-start"><span className="mr-2 text-green-600 mt-1"><FaCheck /></span><span className="inline-flex"> Max. Catalogues: Unlimited</span></li>
              </ul>
              <button className="bg-yellow-500 text-white font-medium px-4 py-2 rounded-full hover:bg-yellow-600">
                Buy Now
              </button>
            </div>
          </div>
        </div>

        <section className="bg-white pb-16 px-4 sm:px-8 lg:px-16 mt-8">
          <div className="mx-auto text-center">
            <h2 className="text-3xl font-bold text-gray-800 mb-5">How It Works</h2>
            <div className="grid gap-6 lg:grid-cols-2">
              {steps.map((step, index) => (
                <div key={index} className="flex items-center p-4 gap-4 rounded-lg border">
                  <div className="flex items-center justify-center w-10 h-10 rounded-full text-white font-semibold text-lg shrink-0" style={{ background: "rgb(116, 83, 224)" }}>
                    {index + 1}
                  </div>
                  <div className="text-left">
                    <h3 className="text-lg font-semibold text-gray-900">{step.title}</h3>
                    <p className="text-gray-600">{step.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

      </div>
    </Layout>
  );
};

export default Inficonnect;

function FeatureCard({ title, description, icon }) {
  return (
    <div className="p-6 bg-gray-50 rounded-lg shadow-lg hover:shadow-xl transition duration-300 transform hover:scale-105">
      <div className="text-4xl">{icon}</div>
      <h3 className="text-xl font-semibold text-gray-800 mt-4">{title}</h3>
      <p className="text-gray-600 mt-2">{description}</p>
    </div>
  );
}
